import { type FC, useId } from "react"

import { cn } from "@forento/ui/utilities/tailwind"

type Option = { id: string; title: string }

type Props = {
	options: [Option, Option]
	selectedId: string
	onChange: (id: string) => void
	label?: string
	className?: string
}

const ToggleGroup: FC<Props> = ({ options, selectedId, onChange, label, className }) => {
	const [left, right] = options
	const labelId = useId()

	return (
		<div className={cn("flex flex-col gap-2", className)}>
			{label !== undefined && (
				<span id={labelId} className="text-xs font-medium tracking-widest text-stone-500 uppercase">
					{label}
				</span>
			)}
			<fieldset
				aria-labelledby={label !== undefined ? labelId : undefined}
				className="bg-component-background inline-flex overflow-hidden rounded-xl p-1"
			>
				<button
					type="button"
					onClick={() => onChange(left.id)}
					aria-pressed={selectedId === left.id}
					className={cn(
						"focus-visible:outline-primary cursor-pointer rounded-lg px-4 py-2.5 text-sm font-medium transition-colors duration-150 focus-visible:outline-2 focus-visible:outline-offset-2",
						selectedId === left.id
							? "bg-primary/8 text-primary font-semibold"
							: "text-slate-600 hover:bg-black/4 hover:text-slate-950",
					)}
				>
					{left.title}
				</button>
				<button
					type="button"
					onClick={() => onChange(right.id)}
					aria-pressed={selectedId === right.id}
					className={cn(
						"focus-visible:outline-primary cursor-pointer rounded-lg px-4 py-2.5 text-sm font-medium transition-colors duration-150 focus-visible:outline-2 focus-visible:outline-offset-2",
						selectedId === right.id
							? "bg-primary/8 text-primary font-semibold"
							: "text-slate-600 hover:bg-black/4 hover:text-slate-950",
					)}
				>
					{right.title}
				</button>
			</fieldset>
		</div>
	)
}

export default ToggleGroup
